<template>
  <div
    class="block-header-container"
    :class="[
      device_platform,
      is_scrolled ? 'block-header-container--scrolled' : '',
    ]"
  >
    <div class="content-container">
      <div class="logo-name-container">
        <div class="logo logo--rolf">
          <a
            @click.prevent="
              $emit('call-order', { title1: 'Получить предложение' })
            "
            href="#form_popup"
          >
            <img
              class="dealer-logo"
              src="../img/logo/rolf 32.png"
              alt="logo_rolf"
            />
            <span>Официальный дилер с 1991 года</span>
          </a>
        </div>
      </div>

      <div class="tg">
        <p>Напишите нам</p>
        <a href="https://t.me/ROLF_official_bot" target="_blank">
          <img src="../img/telegramm-icon.svg" alt="Tg" />
          <span>Telegram</span>
        </a>
      </div>

      <div class="logo--autodealer">
        <a
          @click.prevent="
            $emit('call-order', { title1: 'Получить предложение' })
          "
          href="#form_popup"
        >
        </a>
        <img
          v-if="device_platform === 'desktop'"
          src="../img/logo/logo-award.svg"
          alt=""
          class="logo-award"
        />
      </div>

      <div class="address-worktime-container">
        <a href="#map1">Схема проезда</a>
      </div>

      <div class="btn-common">
        <a
          class="btn-red"
          href="#form_popup"
          @click.prevent="$emit('call-order', { title1: 'Заказать звонок' })"
          >Заказать звонок</a
        >
        <div class="phone-container">
          <a :href="'tel:+' + phone_raw">{{ phone }}</a>
        </div>
      </div>
      <div
        class="logo-name-container logo-name-container_mitsubishi"
        v-if="device_platform !== 'mobile'"
      >
        <div class="logo logo--mitsubishi">
          <a
            @click.prevent="
              $emit('call-order', { title1: 'Получить предложение' })
            "
            href="#form_popup"
          >
            <img src="../img/logo/logo-big.png" alt="logo_mitsubishi" />
          </a>
        </div>
      </div>
      <div class="logo-name-container" v-else>
        <div class="logo logo--mitsubishi">
          <a
            @click.prevent="
              $emit('call-order', { title1: 'Получить предложение' })
            "
            href="#form_popup"
          >
            <img src="../img/logo1.png" alt="logo_mitsubishi" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Mixin from "../common/mixin";

export default {
  name: "block-header",
  mixins: [Mixin],
  data() {
    const { phone, phone_raw, offices } = this.CONSTANTS;

    return {
      phone,
      phone_raw,
      offices,
      is_scrolled: 0,
    };
  },
  mounted() {
    $(window).on("scroll", () => {
      this.is_scrolled = window.scrollY;
    });
  },
};
</script>

<style lang="scss" scoped>
.dealer-logo {
  max-width: 208px;
}

.tg {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
  font-weight: 500;

  p {
    margin-bottom: 5px;
  }

  span {
    display: none;
  }

  @media (max-width: 900px) {
    p {
      display: none;
    }

    a {
      display: flex;
      align-items: center;
    }

    span {
      display: inline;
      margin-left: 5px;
    }
  }

  @media (max-width: 440px) {
    order: 7;
    margin-top: 10px;
    width: 100%;
  }
}

.block-header-container {
  background: white;
  // position: fixed;
  // top: 0;
  // z-index: 10;
  width: 100%;

  &--scrolled {
    border-bottom: 1px solid #686d71;
  }
}

.content-container {
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px auto;
  max-width: 1140px;
  padding: 15px 15px;
  text-align: center;

  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
}

.address-worktime-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 12px;
  font-weight: 500;

  @media (max-width: 767px) {
    display: none;
  }

  a {
    color: #ee0000;
    text-decoration: underline;
  }
}

.phone-container {
  margin-top: 5px;
  @media (max-width: 767px) {
    width: 100%;
    text-align: center;
    order: 3;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    padding: 0 10px;
  }

  a {
    color: #ed0000;
    font-size: 20px;
    font-weight: 500;

    @media (max-width: 991px) and (min-width: 768px) {
      white-space: nowrap;
    }
  }
}

.btn-common {
  @media (max-width: 767px) {
    width: 100%;
    margin-top: 10px;
    order: 2;
  }

  .btn-red {
    height: 46px;
    width: 230px;

    @media (max-width: 767px) {
      width: 100%;
    }

    @media (max-width: 1199px) and (min-width: 768px) {
      height: 46px;
      width: 170px;
    }
  }
}

.logo--rolf {
  text-align: center;

  @media (max-width: 320px) {
    width: 70%;
  }

  span {
    display: block;
    font-size: 13px;
  }
}

.logo--autodealer {
  position: relative;
  & a {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.logo-name-container_mitsubishi {
  position: relative;
  right: 0;
  top: -45px;
  height: 0;
  z-index: 1;
}

.logo-name-container {
  @media (max-width: 767px) {
    order: 1;
  }
}

.logo-award {
  max-width: 150px;
}

@media (max-width: 800px) {
  .block-header-container {
    position: relative;

    &--scrolled {
      border: 0;
    }
  }
}
</style>
